/* docs/API.md → Enums. */
export enum ActivityKind {
    TaskCreated         = 'task_created',
    TaskUpdated         = 'task_updated',
    StatusChanged       = 'status_changed',
    Assigned            = 'assigned',
    ScheduleChanged     = 'schedule_changed',
    DependenciesChanged = 'dependencies_changed',
    CommentAdded        = 'comment_added',
    AttachmentAdded     = 'attachment_added',
    AttachmentRemoved   = 'attachment_removed',
    TaskDeleted         = 'task_deleted',
    ProjectCreated      = 'project_created',
    ProjectUpdated      = 'project_updated',
    MembersChanged      = 'members_changed',
}
